<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>ADRESSE EMAIL DÉJÀ CONFIRMÉE</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>ADRESSE EMAIL DÉJÀ CONFIRMÉE</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="post-job-area pt-5 pb-100 mt-5">
    <div class="container text-left">
        <img src="assets/guides/02.png" alt="" width="150" />
        <div class="pt-5">
            <h4>Email Déjà Vérifié</h4>
            <h5>Cher(e) fournisseur,</h5>
            <p>
                Notre système indique que votre adresse email a déjà été confirmée précédemment.
                Aucune action supplémentaire n'est requise de votre part.
            </p>
            <p>
                Si vous n'avez pas effectué cette vérification ou si vous rencontrez des problèmes
                pour accéder à votre compte, veuillez contacter notre équipe de support.
            </p>
            <p>
                Vous pouvez dès à présent vous connecter à votre compte en utilisant
                vos identifiants.
            </p>
            <p>Cordialement,</p>
            <p>L'équipe de support de la Bourse des Sous-Traitance et de Partenariats</p>
            <div class="pt-100">
                <button routerLink="/login" class="btn btn-outline-main" type="submit">
                    Se connecter <i class="icofont-arrow-right"></i>
                </button>
                <button routerLink="/contact" class="btn btn-outline-secondary ml-3" type="submit">
                    Contacter le support
                </button>
            </div>
        </div>
    </div>
</div>